import React from 'react';

export default function Button({ children, variant = 'secondary', size = 'sm', onClick, disabled, style }) {
  const base = {
    display: 'inline-flex', alignItems: 'center', gap: 5,
    fontFamily: 'inherit', fontWeight: 500, cursor: disabled ? 'not-allowed' : 'pointer',
    borderRadius: 'var(--radius-sm)', border: 'none', transition: 'all 0.1s',
    opacity: disabled ? 0.5 : 1,
    fontSize: size === 'sm' ? 12 : 13,
    padding: size === 'sm' ? '5px 11px' : '7px 15px',
  };
  const variants = {
    primary: {
      background: 'var(--color-accent)',
      color: '#fff',
    },
    secondary: {
      background: 'var(--color-surface-hover)',
      color: 'var(--color-text-secondary)',
      border: '1px solid var(--color-border)',
    },
    ghost: {
      background: 'transparent',
      color: 'var(--color-text-secondary)',
    },
    danger: {
      background: 'var(--color-danger-light)',
      color: 'var(--color-danger)',
    },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{ ...base, ...variants[variant], ...style }}>
      {children}
    </button>
  );
}
